<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="发货预测名称">
              <global-select
                :value.sync="queryParams.shipmentForecastName"
                selectType="select"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.shipmentForecastVersionList"
                selectType="select"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="select"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastStatus"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :selectedRows.sync="selectedRows"
          :multi-select="false"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

        <script>
    import { listShipmentForecast, apiDeleteShipmentForecast } from '@/api/scp/shipmentForecast/shipmentForecastManagement'
    import { generateLsTableResData } from '@/utils/util.js'
    export default {
      // eslint-disable-next-line
      name: 'runningStatus',
      components: {},
      data () {
        return {
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 表格配置
          tableProps: {
            requestApi: generateLsTableResData(listShipmentForecast, true),
            pageCurrent: true
          },
          // 查询参数
          queryParams: {
            shipmentForecastName: undefined,
            shipmentForecastVersionList: undefined,
            statusList: undefined
          },
          baseUomFlagOptions: [
            {
              dictLabel: '是',
              dictValue: 'Y'
            },
            {
              dictLabel: '否',
              dictValue: 'N'
            }
          ],
          // 表格字段
          columns: [
            {
              title: '序号',
              dataIndex: 'shipmentForecastName',
              scopedSlots: { customRender: 'shipmentForecastName' },
              align: 'center',
              width: 120
            },
            {
              title: '阶段名称',
              dataIndex: 'shipmentForecastVersion',
              ellipsis: true,
              width: 120,
              align: 'center'
            },
            {
              title: '说明',
              dataIndex: 'parameterVersion',
              width: 120,
              align: 'center'
            },
            {
              title: '状态',
              width: 120,
              dataIndex: 'shipmentForecastVersion',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '更新人',
              width: 120,
              dataIndex: 'status',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '开始时间',
              width: 120,
              dataIndex: 'updateName',
              align: 'center'
            },
            {
              title: '结束时间',
              width: 120,
              dataIndex: 'updateTime',
              ellipsis: true,
              align: 'center'
            }
          ]
        }
      },
      created () {
        this.getLastSalesForecast()
      },
      mounted () {
        this.onSearch()
      },
      methods: {
        deleteShipmentForecast (record) {
          apiDeleteShipmentForecast(record.id).then((response) => {
            if (response.code === 200) {
              this.$message.success('删除成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        /** 行选中 */
        selectedRowChange (selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        // 表单搜索
        onSearch () {
          this.$refs.dataTable.searchParams = this.queryParams
          this.$refs.dataTable.getData()
        },
        // 编辑-保存
        handleSave () {
          // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          //   this.$message.warning('折换不能为空且需大于0')
          //   return
          // }
          //  const tableData = this.$refs.dataTable.myDataSource;
          //   listUpdateNetSubInventory(tableData).then(response => {
          //     if (response.code === 200) {
          //       this.$message.success('保存成功')
          //       this.onSearch()
          //     } else {
          //       this.$message.error(response.msg)
          //     }
          //   })
        },
        // 取消
        handleCancel (record) {},
        statusOnChange (record) {
          record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
        }
      }
    }
    </script>

        <style scoped lang="less">
    .ml10 {
      margin-left: 10px;
    }
    </style>
